import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

const COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'UK', label: 'United Kingdom' },
  { value: 'AU', label: 'Australia' },
  { value: 'PH', label: 'Philippines' },
  { value: 'MX', label: 'Mexico' },
  { value: 'BR', label: 'Brazil' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'RS', label: 'Serbia' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'ES', label: 'Spain' },
  { value: 'AE', label: 'UAE' },
  { value: 'DE', label: 'Germany' },
] as const

interface CountrySelectorProps {
  value?: string | null
  onChange: (country: string) => void
  placeholder?: string
}

export function CountrySelector({
  value,
  onChange,
  placeholder = 'Select country',
}: CountrySelectorProps) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-full">
        <SelectValue placeholder={placeholder}/>
      </SelectTrigger>
      <SelectContent>
        {COUNTRIES.map((country) => (
          <SelectItem key={country.value} value={country.value}>
            <div>
              <span>{country.label}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
